import CreateFolderModal from './create-folder-modal';

export default CreateFolderModal;
